// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
export default {
    category1PromptText: "Create a project with presentation mode, showing executive slides based on the project data.",
    category1Text: "Presentation",
    category2PromptText: "Create an IT inventory management system that displays our assets, quantities, resupply needs, and allows for updating stock levels. Use a left pane navigation pattern.",
    category2Text: "Inventory app",
    category3PromptText: "Create a FAQ documentation page based on monday board data.",
    category3Text: "Documentation page",
    category4PromptText: "Create an HR recruitment management app, showing applicants' details with a visual interview timeline and an easy way to move an applicant between stages.",
    category4Text: "Recruiting app",
    category5PromptText: "Create a time tracker for employees that allows simple time entry and provides a weekly overview and chart, with the option to log both billable and unbillable hours.",
    category5Text: "Time tracker",
    category6PromptText: "Create a beautiful event website based on board data, with an agenda, speakers, and registration form.",
    category6Text: "Event portal",
    headingBlack1: "Build any",
    headingBlack1Visibility: true,
    headingBlack2: "in minutes",
    headingBlack2Visibility: true,
    headingGradient: " business software ",
    hideComponent: true,
    sectionSubtitle: "Reduce costs and clutter by replacing disconnected tools with custom apps tailored to how your business actually works.",
    vibePromptBoxText: "What do you want to build?"
};
